import React from "react";
import { Link } from "react-router-dom";
import "./VideoCard.css";

const VideoCard = () => {
  return (
    <>
      <div
        style={{ backgroundColor: "white" }}
        className="container-fluid px-0 palantir-card video-card-shell d-flex align-items-center "
      >
        <div className="row w-100 m-0 align-items-center gy-4">
          <div className="col-12 col-lg-6 col-md-7 video-card-media">
            <div
              className="video-card-frame"
              style={{
                position: "relative",
                paddingBottom: "64.2857%",
                height: 0,
              }}
            >
              <video
                className="video-card-video"
                src="https://blackroth-images.s3.ap-south-1.amazonaws.com/card_video.mp4"
                // title="Card Video"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                disablePictureInPicture
                controlsList="nodownload noremoteplayback"
                disableRemotePlayback
              />
            </div>
          </div>
          <div className="col-12 col-lg-5 col-md-5 video-Text">
            <h1 className="palantir-title mb-3">
              There is so much left to build
            </h1>
            <p className="palantir-text mb-4" style={{ color: "black" }}>
              From building advanced LLMs and developing intelligent AI models
              to crafting AI-powered chatbots and unlocking insights through
              predictive analysis.
            </p>
            <Link to="/ai-solutions" className="learn-btn">
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoCard;
 
